import { render } from "./Message.vue?vue&type=template&id=95c9238a"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"
script.render = render

export default script